module.exports = __webpack_public_path__ + "static/img/icon-career.7c099e89.svg";